var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLocationIcon = function SvgLocationIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_15623_1",
    "data-name": "Component 15623 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.082,
    height: 19.517,
    viewBox: "0 0 16.082 19.517",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M8.02,11.563a3.4,3.4,0,0,0,3.4-3.4,3.5,3.5,0,0,0-3.4-3.526,3.4,3.4,0,0,0-3.4,3.4A3.589,3.589,0,0,0,8.02,11.563ZM2.305,2.321A8.083,8.083,0,0,1,13.736,13.752L8.02,19.467,2.305,13.752A8.3,8.3,0,0,1,2.305,2.321Z",
    transform: "translate(-0.025 0.05)",
    fill: "#25556e",
    fillRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLocationIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/location-icon.cd4405149d126489dddc19c70b539ec1.svg";